import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import SetPassword from "./pages/SetPassword";
import Login from "./pages/Login";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./App.css";
// --- 1. Import Toastify & CSS ---
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/toast.css";
import { WorkStatusProvider } from "./context/WorkStatusContext";
import { TabsProvider } from "./context/TabsContext";

// Google authendication
import { GoogleOAuthProvider } from "@react-oauth/google";

// The app screens themselves now live in layouts/screens.js — MainLayout renders
// them as tabs so each one stays mounted while you switch between them.

function App() {
  // 1. Check for Token (This determines if user is logged in)
  const isAuthenticated = !!localStorage.getItem("token");
console.log("API URL:", process.env.REACT_APP_API_LOCAL_URL);
console.log("Google Client:", process.env.REACT_APP_GOOGLE_CLIENT_ID);
  return (
    console.log("Google Client ID:", process.env.REACT_APP_GOOGLE_CLIENT_ID),
    <GoogleOAuthProvider
      clientId="575996333855-fr29aa5ilhicu1ptkc28v2u6obdkdc1s.apps.googleusercontent.com"
    >
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          style={{ zIndex: 9999}}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routes>
          {/* --- PUBLIC ROUTES (Accessible by anyone) --- */}
          <Route path="/login" element={<Login />} />
          <Route path="/set-password" element={<SetPassword />} />
          
          {/* --- ROOT REDIRECT --- */}
          {/* If user visits "/", send to Dashboard if logged in, else Login */}
          <Route
            path="/"
            element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />}
          />

          {/* --- PROTECTED ROUTES (Only accessible if isAuthenticated is true) --- */}
          <Route
            path="/*"
            element={
              isAuthenticated ? (
                // 2. SHOW APP: User has token -> Show Layout & Routes
                <WorkStatusProvider>
                <TabsProvider>
                  <MainLayout />
                </TabsProvider>
                </WorkStatusProvider>
              ) : (
                // 3. HIDE APP: No token -> Redirect to Login
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;